import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import NotFoundPageContent from '@shared/components/loading/NotFoundPageContent';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();

    return (
        <>
            <PageHeader title={t('common:notFound')} items={items} />
            <NotFoundPageContent />
        </>
    );
}
